<template>
  <div>
    <div v-if="events.length > 0">
      <div
        class="event"
        @click="showSingleEventDialog(event)"
      >
        <img src="@/assets/images/reminder_ico.png" class="icon" />
        <div class="text" :id="event.randomEventGuid"><span>{{ timeFormat(new Date(event.startDateTime)) }}</span> {{ event.eventTitle }}</div>
      </div>
    </div>

    <div v-if="events.length > 1" class="more-events" v-click-outside="hideMoreEvents">
      <div class="event">
        <div
          class="text"
          @click="toggleAMoreEvents()"
        >
          {{ events.length - 1 }} more reminder{{ events.length - 1 > 1 ? 's' : ''}}
        </div>
      </div>
      <div
        class="action-menu"
        :class="[ moreEvents ? 'select-menu-collapsed' : 'select-menu-not-collapsed' ]"
      >
        <div
          v-for="eventItem in events"
          :key="eventItem.randomEventGuid"
          v-if="eventItem.eventGuid !== event.eventGuid"
          @click="showSingleEventDialog(eventItem)"
        >
          <span
              :id="eventItem.randomEventGuid"
          >
            {{ eventItem.eventTitle }}
          </span>
        </div>
      </div>
    </div>

    <single-event-tooltip
      v-if="showSingleEventDialogProp"
      :event="selectedEvent"
      :key="rerender"
      @deleteEventModal="deleteEvent"
      v-click-outside="hideTooltip">
    </single-event-tooltip>
  </div>
</template>

<script>
  import SingleEventTooltip from "@/components/appLayout/views/calendar/SingleEventTooltip";
  import { mapActions } from "vuex";
  import { DELETE_SINGLE_EVENT } from "@/store/action.types";
  import vClickOutside from 'v-click-outside'
  import { timeFormat } from '@/mixins/timeFormat';
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: "FPCalendarSingleEvents",
    components: {
      SingleEventTooltip
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    mixins: [
      timeFormat
    ],
    props: {
      childrenList: {
        type: Array,
        required: true,
        default: () => []
      },
      event: {
        type: Object,
        required: true,
        default: () => {}
      },
      events: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data() {
      return {
        selectedEvent: {},
        showSingleEventDialogProp: false,
        rerender: 0,
        moreEvents: false
      }
    },
    mounted() {
    },
    methods: {
      ...mapActions({
        deleteSingleEvent: DELETE_SINGLE_EVENT
      }),
      showSingleEventDialog(event) {
        this.selectedEvent = event
        this.showSingleEventDialogProp = true
        this.rerender+=1
      },
      hideTooltip() {
        this.showSingleEventDialogProp = false
        this.rerender+=1
      },
      findChildName(guid) {
        return this.childrenList.find(child => child.childGuid === guid)
      },
      deleteEvent(eventGuid) {
        this.deleteSingleEvent(eventGuid)
        .then(() => {
          this.showSingleEventDialogProp = false;
          this.$snotify.success(this.$lang.messages.sn_eventSuccessDelete, 'SUCCESS');
          this.$parent.$parent.loadCases();
        })
        .catch(error => {
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          }
        });
      },
      toggleAMoreEvents() {
        this.moreEvents = !this.moreEvents;
      },
      hideMoreEvents() {
        this.moreEvents = false;
      },
    }
  }
</script>
